// External libraries
import React from 'react';
// @ts-expect-error TODO:@checkout/react-components
import { FloatingLabelInput, validateName } from '@checkout/react-components';

// Internal modules
import { features, getContent } from '@/lib';
import { useStoreState } from '@/store';
import { formInputHandlers } from '@/components/Form/formInputHandlers';

/**
 * Wraps validateName to allow empty values for optional name fields.
 * validateName treats empty as valueMissing (invalid), but middleName is optional.
 */
export const validateOptionalName = (
  value: string,
): { errors: string[]; isValid: boolean } => {
  if (!value || !value.trim()) {
    return { errors: [], isValid: true };
  }
  return validateName(value);
};

/**
 * MiddleNameInput - Renders the middle name input field.
 * Used in both addressless flows (Name.tsx) and address flows (CountryAndName).
 * Returns null if middleName is not in the store.
 */
export const MiddleNameInput = (): React.ReactElement | null => {
  const middleName = useStoreState(({ form }) => form.middleName);
  const isFormSubmitting = useStoreState(({ ui }) => ui.isFormSubmitting);
  const theme = features.get('rebrandFormFieldsTheme');

  if (!middleName) {
    return null;
  }

  return (
    <FloatingLabelInput
      autoComplete="additional-name"
      data-testid="middleNameInput"
      disabled={isFormSubmitting}
      hasError={middleName.displayError}
      id="middleName"
      label={getContent('fieldLabels.middleName')}
      maxLength="100"
      name="middleName"
      required={false}
      theme={theme}
      type="text"
      {...middleName}
      {...formInputHandlers}
      validationFn={validateOptionalName}
    />
  );
};
